const DOCUMENT = 'UNIT_MY_TEAM_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  ADD: DOCUMENT + 'ADD',
  ADD_SUCCESS: DOCUMENT + 'ADD_SUCCESS',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  LOAD_CONVERSION_CALCULATOR_DATA_SUCCESS: DOCUMENT + 'LOAD_CONVERSION_CALCULATOR_DATA_SUCCESS',
  TOGGLE_CONVERSION_CALCULATOR_MODAL: DOCUMENT + 'TOGGLE_CONVERSION_CALCULATOR_MODAL',
  CONVERSION_CALCULATOR_CHANGE_PROPERTY: DOCUMENT + 'CONVERSION_CALCULATOR_CHANGE_PROPERTY',
  CLEAR_CONVERSION_CALCULATOR_FORM: DOCUMENT + 'CLEAR_CONVERSION_CALCULATOR_FORM',
  SET_SELECTED_TALENT: DOCUMENT + 'SET_SELECTED_TALENT',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  addSuccess: data => ({
    type: actions.ADD_SUCCESS,
    payload: data,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),

  loadConversionCalculatorDataSuccess: data => ({
    type: actions.LOAD_CONVERSION_CALCULATOR_DATA_SUCCESS,
    payload: data,
  }),

  toggleConversionCalculatorModal: data => ({
    type: actions.TOGGLE_CONVERSION_CALCULATOR_MODAL,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CONVERSION_CALCULATOR_CHANGE_PROPERTY,
    payload: data,
  }),

  clearConversionCalculatorForm: () => ({
    type: actions.CLEAR_CONVERSION_CALCULATOR_FORM,
  }),

  setSelectedTalent: data => ({
    type: actions.SET_SELECTED_TALENT,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
